var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNovaPfp = function SvgNovaPfp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#F1FF66",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191314",
    d: "m16.407 7.308 1.678 6.843c.044.178.186.32.372.368l6.233 1.595a.395.395 0 0 1 0 .771l-6.233 1.596a.51.51 0 0 0-.372.368l-1.678 6.843c-.1.41-.714.41-.814 0l-1.678-6.843a.51.51 0 0 0-.372-.368L7.31 16.885a.395.395 0 0 1 0-.77l6.233-1.596a.51.51 0 0 0 .372-.368l1.678-6.843c.1-.41.714-.41.814 0"
  })));
};
export default SvgNovaPfp;